module.exports = __webpack_public_path__ + "static/factory-wroker-saw-aa32d05fd572abf87ecd99a1f2a7efa9.jpeg";